import {
	getPaymentTabs,
	PaymentTabs,
} from "Payment/Components/Tabs/Hooks/usePaymentTabs";
import { PageContainer } from "Shared/Components/Container";
import { useStateTabs } from "Shared/Components/Tabs/Hooks/useStateTabs";
import { Tabs } from "Shared/Components/Tabs/index";
import { Typography } from "@mui/material";

export function PaymentPage() {
	const paymentTabs = getPaymentTabs();

	return (
		<PageContainer title="Payments" description="List of payments">
			<Typography variant="h2" mb={2}>
				Payments
			</Typography>
			<Tabs
				value={PaymentTabs.all}
				tabs={paymentTabs}
				hookFunction={useStateTabs}
			/>
		</PageContainer>
	);
}
